var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "9px",
    viewBox: "0 0 15 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FA1FB51C-87CE-41E3-AA1F-C06987931BDF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BackOffice",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home_\\xC1rea-logada",
    transform: "translate(-1115.000000, -39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Header",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "next-(1)",
    transform: "translate(1114.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1,8.8 L14.8,2 C15,1.8 15,1.6 15,1.4 C15,1.2 14.9,1 14.8,0.8 L14.3,0.3 C14,1.33226763e-15 13.5,1.33226763e-15 13.1,0.3 L7.6,6 L1.9,0.2 C1.8,0.1 1.6,0 1.4,0 C1.1,0 0.9,0.1 0.8,0.2 L0.3,0.7 C0.1,0.9 0.1,1.1 0.1,1.3 C0.1,1.5 0.2,1.7 0.3,1.9 L7,8.8 C7.1,8.9 7.3,9 7.6,9 C7.8,9 8,8.9 8.1,8.8 Z",
    id: "Path",
    fill: "#FF822F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1,8.8 L14.8,2 C15,1.8 15,1.6 15,1.4 C15,1.2 14.9,1 14.8,0.8 L14.3,0.3 C14,1.33226763e-15 13.5,1.33226763e-15 13.1,0.3 L7.6,6 L1.9,0.2 C1.8,0.1 1.6,0 1.4,0 C1.1,0 0.9,0.1 0.8,0.2 L0.3,0.7 C0.1,0.9 0.1,1.1 0.1,1.3 C0.1,1.5 0.2,1.7 0.3,1.9 L7,8.8 C7.1,8.9 7.3,9 7.6,9 C7.8,9 8,8.9 8.1,8.8 Z",
    id: "Path_1_",
    fill: "#E71037"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.637031ed.svg";
export { ForwardRef as ReactComponent };